import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { FeedbackSuggestedPlanModel } from '../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { largeCourseGroupSmartSearchConfiguration } from '../../configuration/large_course_group_smart_search/large_course_group_smart_search_configuration';
import { smartCatalogConfiguration } from '../../configuration/search_prefab_configuration';
import { HIPModifier } from '../../configuration/sgd_metadata';
import { ApSmartSearchServant } from '../../servants/ap_smart_search_servant';
import { usermode } from '../../types/smart_search_user_modes';
declare const ess: any;
declare const HIP: any;
interface ICourseDetailParams {
  courseNk: string;
  slotType?: 'COURSE';
  allowAddToTerm?: boolean;
  isFromSmartCat?: boolean;
}

export interface ISearchParentCourse {
  plannedCourse: any;
  programSlot: any;
}
export interface ICourseGrupInfo {
  courseGroupValue: string;
  termId: number;
  isInSwapMode: boolean;
  parentCourse: ISearchParentCourse;
  isWildCard: boolean;
}

export class SmartCatalogSearch {
  private isSmartCatalogEnabled: boolean = false;
  private courseGroupValue = '';
  private isSwapModeEnabled = false;
  private parentCourse: ISearchParentCourse = { plannedCourse: {}, programSlot: {} };
  private termId = -1;
  private courseCd = '';
  private selectedCourseNk = '';
  private showAddtoTermDialog = false;
  private isWildCard = false;
  private userMode: usermode = 'student';
  private courseGroupInfo: ICourseGrupInfo = {
    courseGroupValue: '',
    termId: -1,
    isInSwapMode: false,
    parentCourse: { plannedCourse: {}, programSlot: {} },
    isWildCard: false
  };

  constructor(
    private $element: any,
    private $timeout: ng.ITimeoutService,
    private $state: ng.ui.IStateService,
    private appConfigModel: any,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
  ) {}

  $onInit() {
    this.ngComponentCommunicatorService.publish('SMART_SEARCH_TOGGLE_ON');
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.publish('SMART_SEARCH_TOGGLE_OFF');
  }

  /* tslint:disable:cognitive-complexity */
  $onChanges() {
    this.isSmartCatalogEnabled = this.appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
    const feature = this.$element[0].querySelector('#smartCatalogFeature');
    const advisorInViewMode = PlanFeedbackServant.isPlanReadOnlyMode(this.ngFeedbackSuggestedPlanModel.read());
    this.userMode = this.ngAPUserModeConfig.isAdvisor() ? 'advisor' : 'student';
    let courseDetailsRoute;
    let courseDetailsState: string;
    if (this.ngAPUserModeConfig.isAdvisor()) {
      courseDetailsRoute = `advisor/plan/${advisorInViewMode ? 'view' : 'edit'}/default/smart_course_details`;
      courseDetailsState = `ap-advisor.plan.${advisorInViewMode ? 'view' : 'edit'}.default.smart_course_details`;
    } else {
      courseDetailsRoute = 'my/planner/plan/default/smart_course_details';
      courseDetailsState = 'my.planner.plan.default.smart_course_details';
    }
    this.courseGroupInfo = {
      courseGroupValue: this.courseGroupValue,
      termId: this.termId,
      isInSwapMode: this.isSwapModeEnabled,
      parentCourse: this.parentCourse,
      isWildCard: this.isWildCard
    };
    if (!_4.isEmpty(this.courseGroupInfo.courseGroupValue)) {
      if (this.ngAPUserModeConfig.isAdvisor()) {
        courseDetailsState = `ap-advisor.plan.${advisorInViewMode ? 'view' : 'edit'}.coursegroup.course_details`;
      } else {
        courseDetailsState = 'my.planner.plan.coursegroup.course_details';
      }
    }
    const upgrade = new HIPModifier(courseDetailsRoute, courseDetailsState, this.courseGroupInfo);
    if (feature && feature.invoke) {
      feature.invoke(this.smartSearchConfiguration).then(() => {
        const nameSpace = feature['ns'];

        const searchQueryI = HIP.db.gid.queryOne('search_query', nameSpace);
        searchQueryI.addEventListener('invoke-ended', () =>
          this.$element[0].querySelector('hi-grid').removeAttribute('sticky-header')
        );

        HIP.db.gid.queryOne('add_to_term', nameSpace).addEventListener('invoke-ended', (event: any) => {
          this.selectedCourseNk = _4.get(event, 'detail.value.nk', '');
          this.courseCd = _4.get(event, 'detail.value.cd', '');
          this.openDialog();
        });
        HIP.db.gid.queryOne('course_details', nameSpace).addEventListener('invoke-ended', (event: any) => {
          const _courseNk = _4.get(event, 'detail.value.nk', '');
          let courseDetails: ICourseDetailParams = {
            courseNk: _courseNk
          };
          if (_4.includes(courseDetailsState, 'smart_course_details')) {
            courseDetails = {
              ...courseDetails,
              slotType: 'COURSE',
              allowAddToTerm: true
            };
          } else {
            courseDetails = {
              ...courseDetails,
              isFromSmartCat: true
            };
          }
          const params = {
            courseDetails
          };
          this.openCourseDetails(courseDetailsState, params);
        });
      });
      upgrade.invoke();
    }
    ess.on({ status: 'failure' }, (e: CustomEvent) => {
      console.log(e);
    });
  }
  openDialog() {
    this.$timeout(() => {
      this.showAddtoTermDialog = true;
    }, 0);
  }

  openCourseDetails(state: string, params: any) {
    this.$timeout(() => {
      this.$state.go(state, params);
    }, 0);
  }

  get smartSearchConfiguration() {
    let searchConfiguration = smartCatalogConfiguration(this.userMode);
    if (ApSmartSearchServant.isLargeCourseGroupSmartSearch(this.courseGroupInfo)) {
      searchConfiguration = largeCourseGroupSmartSearchConfiguration(this.userMode, this.courseGroupInfo);
    }
    return searchConfiguration;
  }
}

class SmartCatalogSearchComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      courseGroupValue: '<?',
      termId: '<?',
      isSwapModeEnabled: '<?',
      parentCourse: '<?',
      isWildCard: '<?'
    };
    this.controller = SmartCatalogSearch;
    this.templateUrl =
      'capability-ng-academic-planner/src/smart_catalog/components/smart_search/smart_catalog_search.html';
  }
}

angular.module('capability-ng-smartcatalog').component('smartCatalogSearch', new SmartCatalogSearchComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/components/smart_search/smart_catalog_search.ts